"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ServicesLoginApi = void 0;

var _utilsJs = require("@agro1desenvolvimento/utils-js");

var _ = require("..");

var _loginService = _interopRequireDefault(require("../login-service"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

class ServicesLoginApi extends _.APIBase {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "frontendURL", void 0);
  }

  fetchBackendURL(env) {
    if (env === 'production') return 'https://login.aqila.com.br/api';
    if (env === 'test') return 'https://login.aqila.test/api';
    return 'https://login-homologacao.aqila.com.br/api';
  }

  fetchFrontendURL(env) {
    if (env === 'production') return 'https://login.aqila.com.br';
    if (env === 'test') return 'https://login.aqila.test';
    return 'https://login-homologacao.aqila.com.br';
  }

  create({
    frontendURL,
    backendURL
  }) {
    this.frontendURL = frontendURL;
    this.initialize({
      baseURL: backendURL
    });
    this.request.interceptors.response.use(_utilsJs.keysToCamelCaseDeep);
    this.request.interceptors.request.use(request => {
      request.headers = _objectSpread(_objectSpread({}, _loginService.default.requestHeaders()), request.headers);
      return request;
    });
  }

}

exports.ServicesLoginApi = ServicesLoginApi;

var _default = new ServicesLoginApi();

exports.default = _default;